import * as Types from './types';

export interface PathType {
  path: string[];
  type: Types.Type;
}

// Returns a list of all paths for the object.
// Traversing lists are converted to "*",
// nulls and tags are stripped, and dictionary
// properties are converted to keys
export function allObjPaths(
  objectType: Types.Type,
  depth: number = Infinity
): PathType[] {
  let paths: PathType[] = [];
  objectType = Types.nullableTaggableValue(objectType);
  if (Types.isTypedDictLike(objectType)) {
    for (const [key, valType] of Object.entries(
      Types.typedDictPropertyTypes(objectType)
    )) {
      if (valType == null) {
        throw new Error('invalid');
      }
      let childPaths: PathType[] = [];
      if (depth > 0) {
        childPaths = allObjPaths(valType, depth - 1).map(p => ({
          path: [key, ...p.path],
          type: p.type,
        }));
      }
      if (childPaths.length === 0) {
        childPaths = [{path: [key], type: valType}];
      }
      paths = [...paths, ...childPaths];
    }
  } else if (Types.isListLike(objectType) && depth > 0) {
    const valType = Types.listObjectType(objectType);
    const childPaths: PathType[] = allObjPaths(valType, depth - 1)
      .filter(p => p.path.length > 0)
      .map(p => ({
        path: ['*', ...p.path],
        type: p.type,
      }));
    paths = [...paths, ...childPaths];
  }
  return paths;
}
